<style lang='less' scoped>
    // @import './index.less';
    .organization{
        position: fixed;
        top: 44px;
        left: 0px;
        width: 100%;
        z-index: 999;
    }
    .blueColor{
        color: #1989fa;
    }
    .redFont{
        color: #ee0a24;font-weight: bold;font-size: 16px;
    }
    .dropdownTitle{
        // position: relative;
        .labName{
            display: inline-block;
            max-width: 135px;
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 隐藏溢出的内容 */
            text-overflow: ellipsis;
            /* 用省略号表示溢出的内容 */
        }
        .totalNum{
            position: absolute;
            top: -12px;
            right: -14px;
            z-index: 999;
            width: 28px;
            text-align: center;
        }
    }
    
</style>
<template>
    <div class="organization" :style="{top:fixedTop+'px'}">
        <van-dropdown-menu active-color='#1989fa'>
            <van-dropdown-item v-model="collegeId" :options="option1" @change='getLabList'/>
            <van-dropdown-item ref="labVd" v-model="labId" :title="labName">
                <!-- 因为要在下拉框显示未处理的总数量，需要用到插槽，但是如果不设置v-if的话，一开始页面显示是labName默认值，而不是获取到的第一个课题组 -->
                <template slot="title">
                    <div class="dropdownTitle" v-if="labName!=''">
                        <span class="labName">{{labName}}</span>
                        <div class="totalNum">
                            <van-badge :content="totalNum" v-show="totalNum!=0" style="font-size: 12px;"/>
                        </div>
                    </div>
                </template>
                <van-cell center v-for="item in option2" :key="item.value" @click="selectLab(item.value,item.text,item.num)">
                    <template slot="title">
                        <span style="margin-right: 16px;" :class="{blueColor:item.text==labName}">{{item.text}}</span>
                        <!-- <span class="redFont" v-show="item.num!=0">{{item.num}}</span> -->
                        <van-badge :content="item.num" v-show="item.num!=0" style="font-size: 12px;"/>
                    </template>
                    <template slot="right-icon">
                        <van-icon name="success" color="#1989fa" v-show="item.text==labName"/>
                    </template>
                </van-cell>
            </van-dropdown-item>
        </van-dropdown-menu>
    </div>
</template>

<script>
  export default {
    props:{
        fixedTop:{
            type: Number,
            default:44
        }
    },
    computed: {},

    components: {},
    data () {
        return {
            labName:'',
            totalNum:0,
            option1:[],
            option2:[],
            collegeId:0,
            labId:0,
            pathName:''
        };
    },

    created(){
        this.getCollegeList();
        this.pathName=window.location.pathname;
    },

    mounted(){},

    methods: {
        getCollegeList(){
            let data={}
            this.$http.get(this.$store.state.context+'/Lab/GetCollegeList',{params:data}).then(res=>{
                if(res.data.returnCode==1){
                    let option=[];
                    for(let v of res.data.data){
                        option.push({
                            text:v.labName,
                            value:v.labId
                        })
                    }
                    this.option1=option;
                    console.log(this.$store.state.listCollegeId)
                    if(this.pathName=='/list' && this.$store.state.listCollegeId!=0){
                        this.collegeId=this.$store.state.listCollegeId;
                    }else{
                        this.collegeId=this.option1[0].value;
                    }
                    this.selectCollege(this.collegeId);
                }
            })
        },
        selectCollege(collegeLabId){
            let data={
                collegeLabId,
                isShowOpenLockNotHandleCount:1
            }
            this.$http.get(this.$store.state.context+'/Lab/GetLabList',{params:data}).then(res=>{
                if(res.data.returnCode==1){
                    let option=[];
                    for(let v of res.data.data){
                        option.push({
                            text:v.labName,
                            value:v.labId,
                            num:v.openLockNotHandleCount
                        })
                        this.totalNum += v.openLockNotHandleCount;
                    }
                    this.$store.state.openLockNotHandleCount= option[0].num;
                    if(option.length==0){
                        option=[
                            {
                                text:'暂无课题组',
                                value:collegeLabId
                            }
                        ]
                        this.option2=option;
                        this.labId=collegeLabId;
                        this.$emit('selectLabId',this.labId)
                    }else{
                        this.option2=option;
                        if(this.pathName=='/list' && this.$store.state.listLabId!=0){
                            this.labId=this.$store.state.listLabId;
                        }else{
                            this.labId=this.option2[0].value;
                        }
                        this.$emit('selectLabId',this.labId)
                    };
                    this.labName=this.option2[0].text;
                }
            })
        },
        getLabList(collegeLabId){
            if(this.pathName=='/list'){
                this.$store.state.listCollegeId=collegeLabId;
            }
            let data={
                collegeLabId,
                isShowOpenLockNotHandleCount:1
            }
            this.$http.get(this.$store.state.context+'/Lab/GetLabList',{params:data}).then(res=>{
                if(res.data.returnCode==1){
                    let option=[];
                    this.totalNum=0;
                    for(let v of res.data.data){
                        option.push({
                            text:v.labName,
                            value:v.labId,
                            num:v.openLockNotHandleCount
                        })
                        this.totalNum += v.openLockNotHandleCount;
                    }
                    this.$store.state.openLockNotHandleCount= option[0].num;
                    if(option.length==0){
                        option=[
                            {
                                text:'暂无课题组',
                                value:collegeLabId
                            }
                        ]
                        this.option2=option;
                        this.labId=collegeLabId;
                        this.$emit('selectLabId',this.labId)
                    }else{
                        this.option2=option;
                        this.labId=this.option2[0].value;
                        if(this.pathName=='/list'){
                            this.$store.state.listLabId=this.labId;
                        }
                        this.$emit('selectLabId',this.labId)
                    };
                }
                this.labName=this.option2[0].text;
            })
        },
        selectLab(labId,text,num){
            this.labName=text;
            this.$refs.labVd.toggle();
            this.$store.state.openLockNotHandleCount= num;
            if(this.pathName=='/list'){
                this.$store.state.listLabId=labId;
            }
            this.$emit('selectLabId',labId);
        }
    },

    watch: {}
  }

</script>


// WEBPACK FOOTER //
// src/components/organizationAutoShowNum/index.vue